// components/header/topNav.js

'use client'
import React, { useEffect, useState } from "react"
import { useData } from "@/context/hooks/DataProvider"
import { Flex, Typography } from "antd"
import Link from "next/link";
import Image from 'next/image';
import { createClientService } from '@/lib/http/client'
import { isNull } from "@/lib/utils";
import { useRouter } from 'nextjs-toploader/app';


const { Paragraph } = Typography;
export default function TopNav() {

    const router = useRouter();

    const { data, isLogin } = useData()
    if (!data.sysCates || data.sysCates.length === 0) {
        return <div>error</div>
    }


    const [cateIndex, setCateIndex] = useState('Recommen dation');

    const [cateDate, setCateDate] = useState([]);

    const [isShowBg, setIsShowBg] = useState(false);

    // 创建派生数组避免修改原始数据
    const modifiedSysCates = data.sysCates
        ? [{ id: 0, n: 'Recommen dation' }, ...data.sysCates]
        : [];


    useEffect(() => {
        getHostList();
    }, [])

    const getHostList = () => {
        createClientService().get('mtop.cat.hotSysCate').then(res => {
            let newR = [{
                name: res.hot.name,
                children: res.hot.list
            }]
            setCateDate({ ...cateDate, 'Recommen dation': newR })
        })

    }


    const getList = (id, n) => {
        createClientService().get('mtop.cat.subSysCates', { data: { id } }).then(res => {
            setCateDate({ ...cateDate, [n]: res })
        })
    }

    const mainCateHover = (item) => {
        setCateIndex(item.n)

        if (isNull(cateDate[item.n])) {
            getList(item.v, item.n)
        }

    }


    const handleToSearch = (item) => {
        window.open(`/search?searchKey=${item.sysCateName || item.name}&catId=${item.sysCateId || item.id}`)
    }


    // 正常渲染逻辑
    return <Flex className="herder_top_nav" align="center">
        <Flex align="center" className="herder_top_nav_item header_all_categories" onMouseOver={() => setIsShowBg(true)} onMouseOut={() => setIsShowBg(false)}>
            {/* <AppstoreOutlined className="icon_flex" /> */}
            <Image width={16} height={17} src="https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com/PC/yiwuTrade/shop/icon_all_cate.png" alt="All Categories" />
            <span>All Categories</span>

            <div className="all_categories_bx">
                <Flex flex={1} className="categories_bx">
                    <div className="main_cate cate_row_item">
                        {
                            modifiedSysCates.map((item, index) => <div className={["cate_line_item", cateIndex === item.n ? 'active' : ''].join(' ')} key={index} onMouseOver={() => mainCateHover(item)}>{item.n}</div>)
                        }
                    </div>

                    <div className="more_cate cate_row_item">
                        {
                            cateDate[cateIndex]?.map((item, index) => (
                                <React.Fragment key={index}>
                                    <Flex align="center" className="more_cate_title">{item.name}</Flex>
                                    <div className="more_cate_list">
                                        {
                                            item.children?.map((child, index) => (
                                                <div className="more_cate_line" key={index} onClick={() => { handleToSearch(child) }}>
                                                    <Image src={child.picUrl || child.icon} width={80} height={80} alt={child.sysCateName || child.name} />
                                                    <Paragraph ellipsis={{ rows: 2 }}>{child.sysCateName || child.name}</Paragraph>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </React.Fragment>
                            ))
                        }
                    </div>
                </Flex>
            </div>
        </Flex >
        <Link className='herder_top_nav_item' href='/industrialBelt' target="_blank">Source manufacturers by region</Link>
        <Link className='herder_top_nav_item' href='/stock' target="_blank">Products in Stock</Link>
        <Link className='herder_top_nav_item' href='/foreignersServices' target="_blank">Foreigner Service</Link>
        <Link className='herder_top_nav_item' href='/rfq' target="_blank">RFQ</Link>
        {isShowBg && <div className="bg"></div>}
    </Flex >
}